module.exports = __webpack_public_path__ + "assets/img/title-6f55f84c.png";